// Sempre retorna a url da Home não importa em qual pagina esteja
const urlOrigin = new URL(window.location.href).origin;
// Retorna a url ativa no momento
const urlActive = window.location.href;
// Retorna as urls das redes sociais presentes no footer
const socialTag = document.querySelectorAll('.footer__social li a');
const socialUrls = [];
for (const socialHref of socialTag) {
  socialUrls.push('"' + socialHref.getAttribute('href') + '"');
}
// Retorna o caminho do logo setado no background-image no CSS.
let logoPath;
function logoUrl() {
  const logoTag = document.querySelector('.header__logo .logo__image');

  if (logoTag != null) return logoTag.src;
}
logoPath = logoUrl();

let shoppName;
function buildShoppName() {
  const shoppName = document.querySelector('#empreendimentoName');

  if (shoppName != null) return shoppName.getAttribute('title');
}
shoppName = buildShoppName();

const metaDescription = document.getElementsByName('description');
let metaDescriptionContent;
function returnShoppingDescription(metaDescriptionContent) {
  for (const meta of metaDescription) {
    return (metaDescriptionContent = meta.getAttribute('content'));
  }
}
metaDescriptionContent = returnShoppingDescription(metaDescriptionContent);

// 1.0 Tipo website
function setWebSiteSD() {
  const script = document.createElement('script');
  script.setAttribute('type', 'application/ld+json');
  script.textContent = `{
          "@context": "https://schema.org/",
          "@type": "WebSite",
          "name": "${shoppName}",
          "url": "${urlOrigin}",
          "potentialAction": {
            "@type": "SearchAction",
            "target": "${urlOrigin}/busca/?query={search_term_string}", 
            "query-input": "required name=search_term_string"
         }
      }`;
  document.head.appendChild(script);
}

// 2.0 Tipo organização
function setOrganizationSD() {
  const script = document.createElement('script');
  script.setAttribute('type', 'application/ld+json');
  script.textContent = `{
          "@context": "https://schema.org",
          "@type": "Corporation",
          "name": "${shoppName}",
          "alternateName": "${shoppName}",
          "url": "${urlOrigin}",
          "logo": "${logoPath}",
          "sameAs": [${socialUrls}]
      }`;
  document.head.appendChild(script);
}

// 3.0 Tipo webpage
function setWebPageSD() {
  const script = document.createElement('script');
  script.setAttribute('type', 'application/ld+json');
  script.textContent = `{
      "@context":"http://schema.org",
      "type":"WebPage",
      "name":"${shoppName}",
      "description":"${metaDescriptionContent}",
      "url":"${urlActive}",
      "image":"${logoPath}"
      }`;
  document.head.appendChild(script);
}

// Functions Loaded
setWebSiteSD();
setOrganizationSD();
setWebPageSD();
